import React, { type ReactElement } from 'react';
import { type UseQueryResult } from '@tanstack/react-query';
import PaginationForm from 'atom-components/table-pagination/pagination-form';
import type { PaginationFormValues } from 'atom-components/table-pagination/pagination-form/pagination-form.schema';

type Props = {
  query: UseQueryResult<RequestResponse<unknown[]>, RequestError>;
  onChange: ({ pageSize, page }: { pageSize: number; page: number }) => void;
};

/**
 * Paginates a TanStack Table 8 table using a common "meta" object this is returned from the API.
 * Use the provided onChange prop to update the API request and URL params.
 */
export default function TablePagination({ query, onChange }: Props): ReactElement {
  return (
    <PaginationForm
      currentPage={query.data?.meta?.currentPage ?? 0}
      itemsPerPage={query.data?.meta?.itemsPerPage ?? 0}
      totalItems={query.data?.meta?.totalItems ?? 0}
      onSubmit={(formValues: PaginationFormValues): void => {
        onChange({ pageSize: formValues.pageSize, page: formValues.page });
      }}
    />
  );
}
